import { DisplayIconFactory } from './display-icon-factory.interface';
import { DisplayInfoSubIcon, IDisplayInfoIcon } from '@caslink/device-client/ng-app/shared/models/types';
import { ICardDataViewModel } from '@caslink/device-client/ng-app/shared/models/models';

export class HoodFanFactory implements DisplayIconFactory {
    public createDisplayIcon(item: ICardDataViewModel): IDisplayInfoIcon {
        const icon: IDisplayInfoIcon = {
            ...this.createPartialIcon(() => !!item.actualValue),
            getLabelText: () => item.displayValue || item.name,
            isLabelVisible: () => true,
            getValue: () => item.value,
        };

        return icon;
    }

    public createDisplayIconForBehavior(getIsOn: () => boolean): IDisplayInfoIcon {
        const icon: IDisplayInfoIcon = {
            ...this.createPartialIcon(getIsOn),
            getLabelText: () => '',
            isLabelVisible: () => false,
            getValue: () => getIsOn() ? 'true' : 'false',
        };

        return icon;
    }

    private createPartialIcon(getIsOn: () => boolean): Partial<IDisplayInfoIcon> {
        const conditionalCls = [{
            cls: 'rotating',
            condition: getIsOn
        }];

        const subIcon: DisplayInfoSubIcon = {
            icon: 'behaviorHoodFan',
            conditionalCls
        };

        const icon: Partial<IDisplayInfoIcon> = {
            icon: getIsOn() ? 'behaviorHood' : 'behaviorHoodFanOutlined',
            getSubIcon: () => getIsOn() ? subIcon : undefined,
        };

        return icon;
    }
}
